<template>
    <div class="Jur-Cadastro-Principal">
        <PageTitle icon="fa fa-group" main="Administração"
            sub="Juridico / Contrato / Financeiro" />
        <div class="Adm-Juridico-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="Juridico" active><Juridico /></b-tab>
                    <!--
                    <b-tab title="Advogados" active><Advogados /></b-tab>
                    -->
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import Juridico from '../transppass/TranppassBIJuridico'


export default {
    name: 'TranppassBIAdministracaoPrincipal',    
    components: { PageTitle, Juridico }
    
}
</script>

<style>

</style>






